export default __webpack_public_path__ + "static/media/keyboard.06a592a1.svg";